import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective } from "vue"
import _imports_0 from '@assets/images/learn_plan.png'
import _imports_1 from '@/assets/images/studyplan_active.png'
import _imports_2 from '@/assets/images/study_sb.png'


const _hoisted_1 = { class: "study-plan-container" }
const _hoisted_2 = { class: "plan-content-top" }
const _hoisted_3 = { class: "top-right" }
const _hoisted_4 = { class: "use-time-container" }
const _hoisted_5 = { class: "time-container" }
const _hoisted_6 = { class: "time-num" }
const _hoisted_7 = { class: "time-num" }
const _hoisted_8 = {
  key: 0,
  class: "plan-content-bottom"
}
const _hoisted_9 = { class: "first-menu-container" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = {
  src: _imports_1,
  alt: ""
}
const _hoisted_12 = { class: "first-menu-content" }
const _hoisted_13 = { class: "plane-info-container bg-radius" }
const _hoisted_14 = { class: "plane-info-item" }
const _hoisted_15 = { class: "item-value" }
const _hoisted_16 = { class: "plane-info-item" }
const _hoisted_17 = { class: "item-value" }
const _hoisted_18 = { class: "plane-info-item" }
const _hoisted_19 = ["innerHTML"]
const _hoisted_20 = { class: "plane-info-item" }
const _hoisted_21 = { class: "item-value" }
const _hoisted_22 = { class: "plane-info-item" }
const _hoisted_23 = { class: "second-menu-container bg-radius" }
const _hoisted_24 = {
  key: 0,
  class: "none-has-submenu-container"
}
const _hoisted_25 = { class: "none-has-submenu-inner" }
const _hoisted_26 = { class: "item-container" }
const _hoisted_27 = { class: "left-content" }
const _hoisted_28 = { class: "card-title" }
const _hoisted_29 = { class: "card-right-content" }
const _hoisted_30 = { class: "progress-container" }
const _hoisted_31 = { class: "progress-bar" }
const _hoisted_32 = { class: "progress-num" }
const _hoisted_33 = {
  key: 1,
  class: "has-submenu-container"
}
const _hoisted_34 = { class: "submenu-container" }
const _hoisted_35 = ["onClick"]
const _hoisted_36 = { class: "dot-box" }
const _hoisted_37 = { class: "second-menu-info-container" }
const _hoisted_38 = { class: "left-info" }
const _hoisted_39 = ["innerHTML"]
const _hoisted_40 = { class: "card-right-content" }
const _hoisted_41 = { class: "progress-container" }
const _hoisted_42 = { class: "progress-bar" }
const _hoisted_43 = { class: "progress-num" }
const _hoisted_44 = { class: "left-content" }
const _hoisted_45 = { class: "card-title" }
const _hoisted_46 = { class: "card-right-content" }
const _hoisted_47 = { class: "progress-container" }
const _hoisted_48 = { class: "progress-bar" }
const _hoisted_49 = { class: "progress-num" }
const _hoisted_50 = { class: "none-data" }

import { ref, reactive, onMounted, watch, computed, getCurrentInstance, onUnmounted, onBeforeMount } from 'vue'
import getCapabilityOption from '@/hooks/useCapabilityOption'
import { getTrainingPlanMainVo, getTrainingPlanSecVo, getSceneInfoBySceneId, getUserTrainingStatisticsByLimit, createTraining } from '@/service'
import * as echarts from 'echarts';
import { useStore } from 'vuex'
import {$enum, $config} from '@/global/index'
import {useRouter, useRoute} from 'vue-router'

// Props

export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    statisticData: {
        type: Object,
        default:()=>({}),
        required: true
    }
},
  emits: ["onClick", "onClose"],
  setup(__props, { emit: __emit }) {

const props = __props
// Emits定义
const emit = __emit
// 组件状态
const router = useRouter()
const { proxy } = getCurrentInstance()!
const store = useStore()
const firstMenuList = ref<any[]>([])
const currentFirstMenu = ref(0)
const currentSecondMenu = ref(0)
const progressValue = ref(20)
const scrollContainer = ref(null);
const isDragging = ref(false);
const startX = ref(0);
const scrollLeft = ref(0);
const touchStartX = ref(0);
const scrollLeftStart = ref(0);
const options = reactive(getCapabilityOption())
const echart = ref(null)
const loading = ref(false)
const allFlyTime = ref({hour: 0, min: 0})
const mainStasticInfo = reactive({
    planNum:0,
    completedNum: 0,
    flyTime: 0,
    passRate:0,
    scoreNum:0,
    passNum:0
})
const subStasticInfo = reactive({
    planNum:0,
    completedNum: 0,
    flyTime: 0,
    passRate:0,
    scoreNum:0,
    passNum:0
})
const subTypes = ref<any[]>([])
const planItemes = ref<any[]>([])
const windSpeedList = ref<any[]>(['0~0.2','0.3~1.5','1.6~3.3','3.4~5.4','5.5~7.9','8.0~10.7'])


// 监听器和计算属性
// 运行状态
const runStatus = computed(() => {
    if(mainStasticInfo.completedNum === 0 || mainStasticInfo.completedNum == null || mainStasticInfo.completedNum == undefined){
        return '未开始'
    }else if(mainStasticInfo.completedNum > 0 && mainStasticInfo.completedNum < mainStasticInfo.planNum){
        return '进行中'
    }else if(mainStasticInfo.completedNum >= mainStasticInfo.planNum){
        return '已完成'
    }else{
        return ''
    }
})

const subRunStatus = computed(() => {
    if(subStasticInfo.planNum === 0 || subStasticInfo.completedNum === 0){
        return '未开始'
    }else if(subStasticInfo.completedNum > 0 && subStasticInfo.completedNum < subStasticInfo.planNum){
        return '进行中'
    }else{
        return '已完成'
    }
})

const firstFlyinfo = computed(() => {
    if(mainStasticInfo.flyTime > 0){
        let {hour,min} = formatSecondsToHMin(mainStasticInfo.flyTime)
        if(hour){
            return `<span class="item-num">${hour}</span><span class="time-unit">h</span><span class="item-num">${min}</span><span class="time-unit">min</span>`
        }else{
            return `<span class="item-num">${min}</span><span class="time-unit">min</span>`
        }
    }else{
        return '<span class="item-num">0</span>'
    }
})

const secondFlyinfo = computed(() => {
    if(subStasticInfo.flyTime > 0){
        let {hour,min} = formatSecondsToHMin(subStasticInfo.flyTime)
        if(hour){
            return `<span class="item-num">${hour}</span><span class="time-unit">h</span><span class="item-num">${min}</span><span class="time-unit">min</span>`
        }else{
            return `<span class="item-num">${min}</span><span class="time-unit">min</span>`
        }
    }else{
        return '<span class="item-num">0</span>'
    }
})


// 组件方法

const getPageData = async () => { 
    let param = {
        tenantId: store.state.persistence.currentTenantId,
        userId: store.state.persistence.userInfo.userId,
        sceneTypeId: store.state.persistence.breadcrumb[1].id || null,
    }
    firstMenuList.value = []
    currentFirstMenu.value = -1
    let res = await getTrainingPlanMainVo(param) as any;
    if (res?.code == $enum.EnumResult.SUCCESS) {
        let {leftItemList,flyTime} = res.data || {}
        if(Array.isArray(leftItemList) && leftItemList.length){
            firstMenuList.value = leftItemList
            currentFirstMenu.value = 0
            getTrainingPlan()
        }else{
            loading.value = false
        }
        if(flyTime){
            let {hour,min} = formatSecondsToHMin(flyTime)
            allFlyTime.value.hour = hour || 0
            allFlyTime.value.min = min || 0
        }
    }else{
        loading.value = false
    }
    
};

const getTrainingPlan = async () => {
    let param = {
        userId: store.state.persistence.userInfo.userId,
        sceneCategoryId:firstMenuList.value[currentFirstMenu.value]?.sceneCategoryId || null,
        caacType: firstMenuList.value[currentFirstMenu.value]?.caacType || null,
        tenantId: store.state.persistence.currentTenantId,
        sceneTypeId: store.state.persistence.breadcrumb[1].id || null,
    }
    subTypes.value = []
    planItemes.value = []
    currentSecondMenu.value = 0
    let res = await getTrainingPlanSecVo(param) as any;
    if(loading.value){
        loading.value = false
    }
    if (res?.code == $enum.EnumResult.SUCCESS) {
        let {sceneSubTypeId,sceneSubName,planNum,completedNum,planItemList,subTypeList} = res.data || {}
        mainStasticInfo.planNum = planNum
        mainStasticInfo.completedNum = completedNum
        if(subTypeList && Array.isArray(subTypeList)){
            subTypes.value = subTypeList
            subStasticInfo.planNum = subTypes.value[0]?.planNum || 0
            subStasticInfo.completedNum = subTypes.value[0]?.completedNum || 0
            getUserTrainingStatistics(subTypeList[0]?.sceneSubTypeId || null, 2)
        }
        if(Array.isArray(planItemList) && planItemList.length){
            planItemes.value = planItemList
        }
        getUserTrainingStatistics(null, 1)
    }
}

const getUserTrainingStatistics = async (sceneSubTypeId:number | string | null, type:number) => {
    let param = {
        "userId": store.state.persistence.userInfo.userId,
        "tenantId": store.state.persistence.currentTenantId,
        "sceneTypeId": store.state.persistence.breadcrumb[1].id || null,
        "sceneCategoryId": firstMenuList.value[currentFirstMenu.value]?.sceneCategoryId || null,
        "sceneSubTypeId": sceneSubTypeId,
        "size": 9999,
        "current": 1,
        "caacType":null
    }
    if(type == 1 && firstMenuList.value[currentFirstMenu.value]?.caacType){
        param.caacType = firstMenuList.value[currentFirstMenu.value]?.caacType
    }
    if(type == 1){
        //一级菜单在调用
        Object.assign(mainStasticInfo, {
            ...mainStasticInfo,
            flyTime: 0,
            passRate:0,
            scoreNum:0,
            passNum:0
        })
    }
    if(type == 2){
        //二级菜单在调用
        Object.assign(subStasticInfo, {
            ...subStasticInfo,
            flyTime: 0,
            passRate:0,
            scoreNum:0,
            passNum:0
        })
    }
    let res = await getUserTrainingStatisticsByLimit(param) as any;
    if (res?.code == $enum.EnumResult.SUCCESS) {
        if(res.data && Object.keys(res.data).length){
            if(type == 1){
            // 处理一级菜单统计
                Object.assign(mainStasticInfo, {
                    flyTime: res.data.flyTime || 0,
                    passRate:res.data.passRate || 0,
                    scoreNum:res.data.scoreNum || 0,
                    passNum:res.data.passNum || 0
                });
            } else if(type == 2){
                // 处理二级菜单统计
                Object.assign(subStasticInfo, {
                    flyTime: res.data.flyTime || 0,
                    passRate:res.data.passRate || 0,
                    scoreNum:res.data.scoreNum || 0,
                    passNum:res.data.passNum || 0
                });
            }
        }
        
    }
}

const handleFirstMenuClick = (index: number) => {
    window?.playClick()
    currentFirstMenu.value = index
    getTrainingPlan()
}
const handleClickSub = (index: number) => {
    window?.playClick()
    if(currentSecondMenu.value == index) return
    currentSecondMenu.value = index
    planItemes.value = subTypes.value[index]?.planItemList || []
    subStasticInfo.planNum = subTypes.value[index]?.planNum || 0
    subStasticInfo.completedNum = subTypes.value[index]?.completedNum || 0
    getUserTrainingStatistics(subTypes.value[index]?.sceneSubTypeId || null, 2)
}

const formatSecondsToHMin = (seconds: number) => {
    // 计算小时和分钟
  const hours = Math.floor(seconds / 3600) || 0;
  const minutes = Math.floor((seconds % 3600) / 60) || 0;
  
  // 格式化输出：如果小时为0，则不显示小时部分
  return {hour:hours,min:minutes};
};

//去学习
const handleGoToStudy = async (item: any) => {
    window?.playClick()
    let stationId = null
    let airLineId = null
    let sceneImageUrl = null
    let nestId = null
    let resourceFileList = []
    
    let seceneResult = await getSceneInfoBySceneId({id:item?.sceneId})
    if(seceneResult?.code != $enum.EnumResult.SUCCESS){
        proxy?.vknMessage.error('获取数据失败，请稍后再试')
        return;
    }
    if(firstMenuList.value[currentFirstMenu.value]?.sceneCategoryId != 3){
        stationId = props.statisticData?.stationId
        airLineId = props.statisticData?.airLineId
        sceneImageUrl = props.statisticData?.scenePictureUrl
        nestId = props.statisticData?.uavNestId
        resourceFileList = props.statisticData?.resourceFileList
    }else{
        stationId = seceneResult.data?.stationId
        airLineId = seceneResult.data?.airLineId
        sceneImageUrl = seceneResult.data?.scenePictureUrl
        nestId = seceneResult.data?.uavNestId
        resourceFileList = seceneResult.data?.resourceFileList
    }
    let param = {
        userId:store.state.persistence.userInfo.userId,
        sceneId:item?.sceneId,
        uavSpecificationId:store.state.persistence.currentUavInfo.uavId,
        airLineId:airLineId,
        difficultyType:seceneResult.data?.difficultyType,
        windPower:item?.windPower,
        windDirection:item?.windDirection,
        stationId,
    }
    let trainingResult = await createTraining(param)
    if(trainingResult?.code != $enum.EnumResult.SUCCESS){
        proxy?.vknMessage.error('获取数据失败，请稍后再试')
        return;
    }
    let currentWindSpeed = windSpeedList.value[item?.windPower]
    if(currentWindSpeed){
        currentWindSpeed = currentWindSpeed.replace("~",",")
    }

    const {trainingId} = trainingResult.data || {};
    store.commit('persistence/setCurrentUavInfo', {
      ...store.state.persistence.currentUavInfo,
      nestId,
      trainingId,
      heightLimit:seceneResult.data?.heightLimit,
      parentName:firstMenuList.value[currentFirstMenu.value]?.sceneCategoryId == 2?'训练':firstMenuList.value[currentFirstMenu.value]?.sceneCategoryId == 4?'通关':'',
      sceneImageUrl,
      sceneInfo:seceneResult.data,
      resourceFileList,
      windSpeedIndex:currentWindSpeed?currentWindSpeed:store.state.persistence.currentUavInfo?.windSpeedIndex,
      windDirectionIndex:currentWindSpeed?8:store.state.persistence.userTrainSettingInfo?.windDirection,
    });
    if(currentWindSpeed){
        store.commit('persistence/setUserTrainingSetting', {
            ...store.state.persistence.userTrainSettingInfo,
            windPower:item?.windPower,
        });
    }

    store.commit("persistence/setStationId", stationId);
    if(firstMenuList.value[currentFirstMenu.value]?.sceneCategoryId == 1){
        //考核
        router.push('/flight/exam')
    }else if(firstMenuList.value[currentFirstMenu.value]?.sceneCategoryId == 2){
        //训练
        router.push('/flight/train')
    }else if(firstMenuList.value[currentFirstMenu.value]?.sceneCategoryId == 3){
        //新手教学
        router.push('/flight/guide')
    }else if(firstMenuList.value[currentFirstMenu.value]?.sceneCategoryId == 4){
        //通关
        router.push('/flight/passTest')
    }
}


// 鼠标拖动功能
const startDrag = (e: MouseEvent) => {
    isDragging.value = true;
    startX.value = e.pageX - scrollContainer.value.offsetLeft;
    scrollLeft.value = scrollContainer.value.scrollLeft;
    e.preventDefault();
};

const doDrag = (e: MouseEvent) => {
    if (!isDragging.value) return;
    e.preventDefault();
    const x = e.pageX - scrollContainer.value.offsetLeft;
    const walk = (x - startX.value) * 2;
    scrollContainer.value.scrollLeft = scrollLeft.value - walk;
};

const endDrag = () => {
    isDragging.value = false;
};

// 鼠标滚轮
const handleWheel = (e: WheelEvent) => {
    if (scrollContainer.value) {
        scrollContainer.value.scrollLeft += e.deltaY * 3;
    }
};

// 触摸设备支持
const startTouch = (e: TouchEvent) => {
    touchStartX.value = e.touches[0].pageX;
    scrollLeftStart.value = scrollContainer.value.scrollLeft;
};

const doTouch = (e: TouchEvent) => {
    if (!touchStartX.value) return;
    const touchX = e.touches[0].pageX;
    const walk = (touchX - touchStartX.value) * 3;
    scrollContainer.value.scrollLeft = scrollLeftStart.value - walk;
    e.preventDefault();
};

const endTouch = () => {
    touchStartX.value = 0;
};

const initEcharts = () => {
    const echartBox = document.getElementById('echartBox') as HTMLElement
    echart.value = echarts.init(echartBox)
    echart.value.setOption(getCapabilityOption('black', 'transparent'))
}

const exportReport = () => {
    const imgBase64 = echart.value.getDataURL({
        type: 'png', // 图片格式，支持 png/jpeg/webp
        pixelRatio: 2, // 图片分辨率比例，默认 1（越高越清晰，文件越大）
        backgroundColor: 'transparent' // 图片背景色，默认透明（#ffffff 为白色）
    });

            // 5. 将 Base64 数据转换为可下载的图片文件
    const link = document.createElement('a');
    link.href = imgBase64;
    link.download = 'echarts截图_' + new Date().getTime() + '.png'; // 下载文件名称
    link.click(); // 触发下载
}

const resizeEcharts = () => {
    echart.value.resize()
    window.addEventListener('resize', resizeEcharts)
}


// 生命周期
onBeforeMount(() => {
    loading.value = true
})

onMounted(() => {
    // initEcharts()
    getPageData()
})

onUnmounted(() => {
    // window.removeEventListener('resize', resizeEcharts)
})

return (_ctx: any,_cache: any) => {
  const _component_vkn_button = _resolveComponent("vkn-button")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[5] || (_cache[5] = _createElementVNode("p", { class: "main-title" }, "学习目录", -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[3] || (_cache[3] = _createElementVNode("p", { class: "time-title" }, "学习总用时", -1)),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("p", null, [
              _createElementVNode("span", _hoisted_6, _toDisplayString(allFlyTime.value.hour), 1),
              _cache[0] || (_cache[0] = _createElementVNode("span", { class: "time-unit" }, "h", -1)),
              _createElementVNode("span", _hoisted_7, _toDisplayString(allFlyTime.value.min), 1),
              _cache[1] || (_cache[1] = _createElementVNode("span", { class: "time-unit" }, "min", -1))
            ]),
            _cache[2] || (_cache[2] = _createElementVNode("img", {
              src: _imports_0,
              alt: ""
            }, null, -1))
          ])
        ]),
        _cache[4] || (_cache[4] = _createElementVNode("div", {
          class: "echart-container",
          id: "echartBox"
        }, null, -1))
      ])
    ]),
    (!loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(firstMenuList.value, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "first-menu-item",
                key: index,
                onClick: ($event: any) => (handleFirstMenuClick(index))
              }, [
                _createElementVNode("p", null, _toDisplayString(item.name), 1),
                _withDirectives(_createElementVNode("img", _hoisted_11, null, 512), [
                  [_vShow, currentFirstMenu.value == index]
                ])
              ], 8, _hoisted_10))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("p", _hoisted_15, _toDisplayString(`${mainStasticInfo.passNum}/${mainStasticInfo.scoreNum}`), 1),
                _cache[6] || (_cache[6] = _createElementVNode("p", { class: "item-title" }, "合格场次", -1))
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("p", _hoisted_17, _toDisplayString(mainStasticInfo.passRate) + "%", 1),
                _cache[7] || (_cache[7] = _createElementVNode("p", { class: "item-title" }, "合格率", -1))
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("p", {
                  class: "item-value",
                  innerHTML: firstFlyinfo.value
                }, null, 8, _hoisted_19),
                _cache[8] || (_cache[8] = _createElementVNode("p", { class: "item-title" }, "累计时间", -1))
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("p", _hoisted_21, _toDisplayString(mainStasticInfo.completedNum) + "/" + _toDisplayString(mainStasticInfo.planNum), 1),
                _cache[9] || (_cache[9] = _createElementVNode("p", { class: "item-title" }, "整体进度", -1))
              ]),
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("p", {
                  class: "item-value",
                  style: _normalizeStyle({'color': runStatus.value === '进行中' ? '#FFA314' : runStatus.value === '已完成' ? '#46B65B' : runStatus.value === '未完成'? '#A2A6B1':'#A2A6B1'})
                }, _toDisplayString(runStatus.value), 5),
                _cache[10] || (_cache[10] = _createElementVNode("p", { class: "item-title" }, "状态", -1))
              ])
            ]),
            _createElementVNode("div", _hoisted_23, [
              (subTypes.value.length == 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                    _createVNode(_component_el_scrollbar, { height: "100%" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_25, [
                          _createElementVNode("div", _hoisted_26, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(planItemes.value, (item, index) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "none-has-submenu-item item-card-main",
                                key: index
                              }, [
                                _createElementVNode("div", _hoisted_27, [
                                  _cache[11] || (_cache[11] = _createElementVNode("div", { class: "icon-box" }, [
                                    _createElementVNode("img", { src: _imports_2 })
                                  ], -1)),
                                  _createElementVNode("p", _hoisted_28, "【" + _toDisplayString(item.planName) + "】" + _toDisplayString(item.planConditions), 1)
                                ]),
                                _createElementVNode("div", _hoisted_29, [
                                  _createElementVNode("div", _hoisted_30, [
                                    _cache[12] || (_cache[12] = _createElementVNode("span", { class: "progress-title" }, "进度", -1)),
                                    _createElementVNode("div", _hoisted_31, [
                                      _createElementVNode("div", {
                                        class: "progress-bar-inner",
                                        style: _normalizeStyle({width:`${item.completedNum / item.planNum * 100}%`})
                                      }, null, 4)
                                    ]),
                                    _createElementVNode("p", _hoisted_32, _toDisplayString(`${item.completedNum}/${item.planNum}`), 1)
                                  ]),
                                  _createVNode(_component_vkn_button, {
                                    label: "去学习",
                                    type: "primary",
                                    size: "tiny",
                                    disabled: !item.enableJumpToTraining,
                                    onClick: ($event: any) => (handleGoToStudy(item))
                                  }, null, 8, ["disabled", "onClick"])
                                ])
                              ]))
                            }), 128))
                          ])
                        ])
                      ]),
                      _: 1
                    })
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_33, [
                    _createElementVNode("div", _hoisted_34, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["submenu-inner-container", { dragging: isDragging.value }]),
                        ref_key: "scrollContainer",
                        ref: scrollContainer,
                        onMousedown: startDrag,
                        onMouseleave: endDrag,
                        onMouseup: endDrag,
                        onMousemove: doDrag,
                        onWheel: _withModifiers(handleWheel, ["prevent"]),
                        onTouchstart: startTouch,
                        onTouchmove: doTouch,
                        onTouchend: endTouch,
                        style: _normalizeStyle({cursor: isDragging.value ? 'grabbing' : 'pointer'})
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(subTypes.value, (item, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "submenu-item",
                            key: index,
                            onClick: ($event: any) => (handleClickSub(index))
                          }, [
                            _createElementVNode("span", {
                              class: _normalizeClass({'active':currentSecondMenu.value == index})
                            }, _toDisplayString(item.sceneSubName), 3),
                            _withDirectives(_createElementVNode("div", _hoisted_36, null, 512), [
                              [_vShow, currentSecondMenu.value == index]
                            ])
                          ], 8, _hoisted_35))
                        }), 128))
                      ], 38)
                    ]),
                    _createElementVNode("div", _hoisted_37, [
                      _createElementVNode("div", _hoisted_38, [
                        _createElementVNode("p", null, "合格/总场次：" + _toDisplayString(`${subStasticInfo.passNum}/${subStasticInfo.scoreNum}`), 1),
                        _createElementVNode("p", null, "合格率：" + _toDisplayString(subStasticInfo.passRate) + "%", 1),
                        _createElementVNode("p", null, [
                          _cache[13] || (_cache[13] = _createTextVNode("时长：")),
                          _createElementVNode("span", { innerHTML: secondFlyinfo.value }, null, 8, _hoisted_39)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_40, [
                        _createElementVNode("div", _hoisted_41, [
                          _cache[14] || (_cache[14] = _createElementVNode("span", { class: "progress-title" }, "进度", -1)),
                          _createElementVNode("div", _hoisted_42, [
                            _createElementVNode("div", {
                              class: "progress-bar-inner",
                              style: _normalizeStyle({width:`${(subStasticInfo.completedNum / subStasticInfo.planNum)* 100}%`})
                            }, null, 4)
                          ]),
                          _createElementVNode("p", _hoisted_43, _toDisplayString(`${subStasticInfo.completedNum}/${subStasticInfo.planNum}`), 1)
                        ]),
                        _createElementVNode("div", {
                          class: _normalizeClass(['status-container', {'in-progress': subRunStatus.value === '进行中', 'not-started': subRunStatus.value === '未开始', 'completed': subRunStatus.value === '已完成'}])
                        }, [
                          _createElementVNode("span", null, _toDisplayString(subRunStatus.value), 1)
                        ], 2)
                      ])
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(subTypes.value[currentSecondMenu.value]?.planItemList, (chileItem, childIndex) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "none-has-submenu-item item-card-main",
                        key: childIndex
                      }, [
                        _createElementVNode("div", _hoisted_44, [
                          _cache[15] || (_cache[15] = _createElementVNode("div", { class: "icon-box" }, [
                            _createElementVNode("img", { src: _imports_2 })
                          ], -1)),
                          _createElementVNode("p", _hoisted_45, "【" + _toDisplayString(chileItem.planName) + "】" + _toDisplayString(chileItem.planConditions), 1)
                        ]),
                        _createElementVNode("div", _hoisted_46, [
                          _createElementVNode("div", _hoisted_47, [
                            _cache[16] || (_cache[16] = _createElementVNode("span", { class: "progress-title" }, "进度", -1)),
                            _createElementVNode("div", _hoisted_48, [
                              _createElementVNode("div", {
                                class: "progress-bar-inner",
                                style: _normalizeStyle({width:`${chileItem.completedNum / chileItem.planNum * 100}%`})
                              }, null, 4)
                            ]),
                            _createElementVNode("p", _hoisted_49, _toDisplayString(`${chileItem.completedNum}/${chileItem.planNum}`), 1)
                          ]),
                          _createVNode(_component_vkn_button, {
                            label: "去学习",
                            type: "primary",
                            size: "tiny",
                            disabled: !chileItem.enableJumpToTraining,
                            onClick: ($event: any) => (handleGoToStudy(chileItem))
                          }, null, 8, ["disabled", "onClick"])
                        ])
                      ]))
                    }), 128))
                  ]))
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("div", _hoisted_50, null, 512), [
      [_directive_loading, loading.value],
      [_vShow, loading.value]
    ])
  ]))
}
}

})